export default __webpack_public_path__ + "static/media/poster.32475730.jpg";